import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c534f0b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "scroll-bar" }
const _hoisted_5 = { class: "game-data" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "game-img" }
const _hoisted_8 = { class: "game-desc" }
const _hoisted_9 = { class: "name ellipsis" }
const _hoisted_10 = { class: "time" }
const _hoisted_11 = { class: "right" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Return", -1))
const _hoisted_14 = { class: "scroll-bar" }
const _hoisted_15 = { class: "qa-main" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "qa-container" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "name ellipsis" }
const _hoisted_20 = ["src"]
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Return", -1))
const _hoisted_23 = { class: "scroll-bar" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { class: "container" }
const _hoisted_27 = { class: "item" }
const _hoisted_28 = { class: "sub-title" }
const _hoisted_29 = { class: "content" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_31 = { class: "item" }
const _hoisted_32 = { class: "sub-title" }
const _hoisted_33 = { class: "content" }
const _hoisted_34 = { class: "container mt-12" }
const _hoisted_35 = { class: "item" }
const _hoisted_36 = { class: "sub-title" }
const _hoisted_37 = { class: "content" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_39 = { class: "item" }
const _hoisted_40 = { class: "sub-title" }
const _hoisted_41 = { class: "content" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_43 = { class: "item" }
const _hoisted_44 = { class: "sub-title" }
const _hoisted_45 = { class: "content" }
const _hoisted_46 = {
  key: 1,
  class: "container"
}
const _hoisted_47 = { class: "item" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "sub-title" }, "CDkey", -1))
const _hoisted_49 = { class: "content" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_51 = { class: "item" }
const _hoisted_52 = { class: "sub-title" }
const _hoisted_53 = { class: "content" }
const _hoisted_54 = { class: "option-area" }
const _hoisted_55 = ["src"]

import {
  apiPurchasedGameDetail,
  apiGetGameQAList,
  apiGetGameQADetail,
} from "@/api/home";
import CusModal from "@/components/CusModal/index.vue";
import { formatDatetime } from "@/js/utils";
import { useLayoutDataStore } from "@/store/layoutData";
import { yunpb } from "@/types/protobuf";
import { storeToRefs } from "pinia";
import { watch, ref, computed } from "vue";
import { handleClipboard } from "@/js/clipboard";
import BusinessManager from "@/js/controls";
import { message } from "ant-design-vue";
import { trackCustomizeEvent } from "@/js/stastic";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const GOODSTYPE = {
  ACCOUNT: 1,
  CDKEY: 2,
};

const layoutDataStore = useLayoutDataStore();
const { purchasedGameModal, purchasedGamesData, activePurchasedGames } =
  storeToRefs(layoutDataStore);
const activePurchasedGamesDetail = ref({} as yunpb.IPurchasedGameDetailRes);
const activeFlag = ref("");
const qaList = ref([] as yunpb.IQATypeInfo[]);
const activeContent = ref("");
const isTutorialRef = ref(false as boolean | undefined);

const purchasedGamesTutorial = computed(() => {
  return activePurchasedGames.value.goodsType === GOODSTYPE.CDKEY
    ? activePurchasedGamesDetail.value.cdkeyUseTutorial
    : activePurchasedGamesDetail.value.accountUseTutorial;
});

const handleClose = () => {
  layoutDataStore.updateStateProp("purchasedGameModal", false);
  activeFlag.value = "";
  activePurchasedGamesDetail.value = {};
  layoutDataStore.updateStateProp(
    "activePurchasedGames",
    layoutDataStore.purchasedGamesData[0]
  );
};
watch(activePurchasedGames, (newVal) => {
  if (newVal) getPurchasedGameDetail(newVal.id as number);
});

const handleReturn = () => {
  isTutorialRef.value ? (activeFlag.value = "") : (activeFlag.value = "help");
};

const handleNextPage = (
  flag: string,
  content?: string,
  isTutorial?: boolean
) => {
  isTutorialRef.value = isTutorial;
  activeFlag.value = flag;
  activeFlag.value === "help" && getGameQa();
  activeFlag.value === "QADetail" &&
    getCurrentGameQaContentcontent(content || "", isTutorial);
};
const getCurrentGameQaContentcontent = async (
  content: string,
  isTutorial?: boolean
) => {
  if (isTutorial) {
    const qaId = getId(content);
    if (!qaId) return;
    try {
      const res = await apiGetGameQADetail({
        qaId: Number(qaId),
      });
      activeContent.value = res.content as string;
      console.log(res, "apiGetGameQADetail");
    } catch (error) {
      console.log(error, "apiGetGameQADetailErr");
    }
  } else {
    activeContent.value = content;
  }
};
const getId = (str: string) => {
  var res = new RegExp("(?:&|/?)" + "id" + "=([^&|#$]+)").exec(str);
  return res ? res[1] : "";
};
const getGameQa = async () => {
  try {
    const res = await apiGetGameQAList({
      gameId: activePurchasedGames.value.cloudGameData?.cloudGameId,
      qaType: 2,
    });
    qaList.value = res.qaTypeInfoList as yunpb.IQATypeInfo[];
    console.log(res, "GetQAListResp");
    trackCustomizeEvent({
      event_id: "chikiiweb-purchasedGames-help-click",
    });
  } catch (error) {
    console.log(error, "GetQAListResp");
  }
};

const formatTime = (time: number) => {
  const resTime = formatDatetime(time * 1000);
  return `${resTime.year}.${resTime.month}.${resTime.day} ${resTime.hour}:${resTime.minute}`;
};
const getPurchasedGameDetail = async (id: number) => {
  try {
    const res = await apiPurchasedGameDetail({
      id,
      goodsType: activePurchasedGames.value.goodsType,
    });
    activePurchasedGamesDetail.value = res;
    console.log(res, "apiPurchasedGameDetail");
  } catch (error) {
    console.log(error, "apiPurchasedGameDetail");
  }
};

// 复制
const handleCopy = (copyText: string, e: any) => {
  if (e) handleClipboard(copyText || "123", e);
};
// 跳转 link
const handleLink = (link: string) => {
  if (!link) return;
  location.href = link;
};

// 玩游戏
const handelPlay = async (game: yunpb.IPurchasedGame) => {
  const res = await BusinessManager.GetGameRoomInfo(
    game.cloudGameData?.cloudGameId
  );
  console.log("游戏排队", res);
  if (res?.code !== 0) {
    const err = res?.obj as { desc: string; func: string; obj: string };
    message.error(err.desc);
    return;
  }
  const gameInfo = res && res.obj;
  window.gameStateMgr.playGame(gameInfo);
  trackCustomizeEvent({
    event_id: "chikii_gameMall_purchasedGames_play",
  });
};

const handleChangePurchasedGames = (game: yunpb.IPurchasedGame) => {
  activePurchasedGamesDetail.value = {};
  activeFlag.value = "";
  layoutDataStore.updateStateProp("activePurchasedGames", game);
};

return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createBlock(CusModal, {
    isShow: _unref(purchasedGameModal),
    width: "960px",
    onOnClose: handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("PurchassedGameModal.title")), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(purchasedGamesData), (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["game-item", [_unref(activePurchasedGames).id === item.id ? 'active' : '']]),
                  key: item.id!,
                  onClick: ($event: any) => (handleChangePurchasedGames(item))
                }, [
                  _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
                    [_directive_lazy, item.goodsImg]
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(item.goodsName), 1),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(formatTime(item.completeTime)), 1)
                  ])
                ], 10, _hoisted_6))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (activeFlag.value === 'help')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", {
                  class: "return-btn mb-24",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (activeFlag.value = ''))
                }, [
                  _createElementVNode("img", {
                    src: require('@/assets/img/icon-return.svg'),
                    alt: ""
                  }, null, 8, _hoisted_12),
                  _hoisted_13
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qaList.value, (qa) => {
                      return _withDirectives((_openBlock(), _createElementBlock("div", {
                        class: "qa-item",
                        key: qa.typeTitle!
                      }, [
                        _createElementVNode("p", _hoisted_16, _toDisplayString(qa.typeTitle || "1"), 1),
                        _createElementVNode("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qa.qaInfoList, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "qa-item-info",
                              key: item.id,
                              onClick: ($event: any) => (handleNextPage('QADetail', item.content!))
                            }, [
                              _createElementVNode("p", _hoisted_19, _toDisplayString(item.title), 1),
                              _createElementVNode("img", {
                                class: "icon-next",
                                src: require('@/assets/img/icon-return.svg'),
                                alt: ""
                              }, null, 8, _hoisted_20)
                            ], 8, _hoisted_18))
                          }), 128))
                        ])
                      ])), [
                        [_vShow, qa.qaInfoList?.length]
                      ])
                    }), 128))
                  ])
                ])
              ], 64))
            : (activeFlag.value === 'QADetail')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", {
                    class: "return-btn mb-24",
                    onClick: handleReturn
                  }, [
                    _createElementVNode("img", {
                      src: require('@/assets/img/icon-return.svg'),
                      alt: ""
                    }, null, 8, _hoisted_21),
                    _hoisted_22
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", {
                      class: "qa-main",
                      innerHTML: activeContent.value
                    }, null, 8, _hoisted_24)
                  ])
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(activePurchasedGames).goodsName || "goodsName"), 1),
                  (_unref(activePurchasedGames).goodsType === GOODSTYPE.ACCOUNT)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$t("PurchassedGameModal.SteamAccount")), 1),
                            _createElementVNode("p", _hoisted_29, _toDisplayString(activePurchasedGamesDetail.value.gameAccount || "shhs "), 1),
                            _createElementVNode("div", {
                              class: "copy-btn flex-btn pa pat-5 par-0",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (
                    handleCopy(activePurchasedGamesDetail.value.gameAccount!, $event)
                  ))
                            }, _toDisplayString(_ctx.$t("PurchassedGameModal.copy")), 1)
                          ]),
                          _hoisted_30,
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("PurchassedGameModal.SteamPassword")), 1),
                            _createElementVNode("p", _hoisted_33, _toDisplayString(activePurchasedGamesDetail.value.gamePasswd || "shshh"), 1),
                            _createElementVNode("div", {
                              class: "copy-btn flex-btn pa pat-5 par-0",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (
                    handleCopy(activePurchasedGamesDetail.value.gamePasswd!, $event)
                  ))
                            }, _toDisplayString(_ctx.$t("PurchassedGameModal.copy")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("PurchassedGameModal.EmailAccount")), 1),
                            _createElementVNode("p", _hoisted_37, _toDisplayString(activePurchasedGamesDetail.value.emailAccount || "shshh"), 1),
                            _createElementVNode("div", {
                              class: "copy-btn flex-btn pa pat-5 par-0",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (
                    handleCopy(activePurchasedGamesDetail.value.emailAccount!, $event)
                  ))
                            }, _toDisplayString(_ctx.$t("PurchassedGameModal.copy")), 1)
                          ]),
                          _hoisted_38,
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.$t("PurchassedGameModal.EmailPassword")), 1),
                            _createElementVNode("p", _hoisted_41, _toDisplayString(activePurchasedGamesDetail.value.emailPasswd || "shshh"), 1),
                            _createElementVNode("div", {
                              class: "copy-btn flex-btn pa pat-5 par-0",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (
                    handleCopy(activePurchasedGamesDetail.value.emailPasswd!, $event)
                  ))
                            }, _toDisplayString(_ctx.$t("PurchassedGameModal.copy")), 1)
                          ]),
                          _hoisted_42,
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.$t("PurchassedGameModal.EmailWebsite")), 1),
                            _createElementVNode("p", _hoisted_45, _toDisplayString(activePurchasedGamesDetail.value.emailWeb || "shshh"), 1),
                            _createElementVNode("div", {
                              class: "copy-btn flex-btn pa pat-5 par-62",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (handleLink(activePurchasedGamesDetail.value.emailWeb!)))
                            }, " Go "),
                            _createElementVNode("div", {
                              class: "copy-btn flex-btn pa pat-5 par-0",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (
                    handleCopy(activePurchasedGamesDetail.value.emailWeb!, $event)
                  ))
                            }, _toDisplayString(_ctx.$t("PurchassedGameModal.copy")), 1)
                          ])
                        ])
                      ], 64))
                    : (_unref(activePurchasedGames).goodsType === GOODSTYPE.CDKEY)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _createElementVNode("p", _hoisted_49, _toDisplayString(activePurchasedGamesDetail.value.cdkey || "shhs "), 1),
                            _createElementVNode("div", {
                              class: "copy-btn flex-btn pa pat-5 par-0",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (handleCopy(activePurchasedGamesDetail.value.cdkey!, $event)))
                            }, _toDisplayString(_ctx.$t("PurchassedGameModal.copy")), 1)
                          ]),
                          _hoisted_50,
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.$t("PurchassedGameModal.ActivationWebsite")), 1),
                            _createElementVNode("p", _hoisted_53, _toDisplayString(activePurchasedGamesDetail.value.cdkeyActivationAddress || "shshh"), 1),
                            _createElementVNode("div", {
                              class: "copy-btn flex-btn pa pat-5 par-62",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (
                    handleLink(
                      activePurchasedGamesDetail.value.cdkeyActivationAddress!
                    )
                  ))
                            }, " Go "),
                            _createElementVNode("div", {
                              class: "copy-btn flex-btn pa pat-5 par-0",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (
                    handleCopy(
                      activePurchasedGamesDetail.value.cdkeyActivationAddress!,
                      $event
                    )
                  ))
                            }, _toDisplayString(_ctx.$t("PurchassedGameModal.copy")), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", {
                      class: "btn w-100 flex-btn",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (handleNextPage('help')))
                    }, _toDisplayString(_ctx.$t("PurchassedGameModal.help")), 1),
                    _createElementVNode("div", {
                      class: "btn flex-btn",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (handleNextPage('QADetail', _unref(purchasedGamesTutorial)!, true)))
                    }, _toDisplayString(_unref(activePurchasedGames).goodsType === GOODSTYPE.CDKEY
                  ? _ctx.$t("PurchassedGameModal.CDKEYActivatetutorial")
                  : _ctx.$t("PurchassedGameModal.tutorial")), 1),
                    _withDirectives(_createElementVNode("div", {
                      class: "btn2 w-200 flex-btn",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (handelPlay(_unref(activePurchasedGames))))
                    }, [
                      _createElementVNode("img", {
                        src: require('@/assets/img/icon-play.svg'),
                        alt: ""
                      }, null, 8, _hoisted_55),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t("PurchassedGameModal.play")), 1)
                    ], 512), [
                      [_vShow, _unref(activePurchasedGames).goodsType === GOODSTYPE.ACCOUNT]
                    ])
                  ])
                ], 64))
        ])
      ])
    ]),
    _: 1
  }, 8, ["isShow"]))
}
}

})